import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Columns, Column, Box, Stack, Text } from "braid-design-system";
import { HirerBalanceLayout } from "../AdBudgetsUpsell/AdBudgetsUpsell.mjs";
import { translations } from "../../../../HirerContractBalance/components/ErrorAlert/.vocab/index.mjs";
import { icon } from "../../HirerBalancePresentation.css.mjs";
const ErrorLogo = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "96",
    height: "96",
    viewBox: "0 0 71 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M66.9003 50.7149H4.45198C2.38262 50.7149 0.705078 49.0373 0.705078 46.968V40.7231H70.6472V46.968C70.6472 49.0373 68.9697 50.7149 66.9003 50.7149Z",
          fill: "#6E56E6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M48.1657 65.7024H23.1864C21.8069 65.7024 20.6885 64.584 20.6885 63.2045C20.6885 61.825 21.8069 60.7065 23.1864 60.7065H48.1657C49.5452 60.7065 50.6637 61.825 50.6637 63.2045C50.6637 64.584 49.5452 65.7024 48.1657 65.7024Z",
          fill: "#6E56E6"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M45.668 50.7148H25.6846V60.7066H45.668V50.7148Z", fill: "#392BA7" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.44124 0.756348H66.8896C68.9576 0.756348 70.6365 2.43527 70.6365 4.50325V40.7233H0.694336V4.50325C0.694336 2.43527 2.37326 0.756348 4.44124 0.756348Z",
          fill: "#392BA7"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.6767 46.9652C36.3665 46.9652 36.9257 46.406 36.9257 45.7163C36.9257 45.0265 36.3665 44.4673 35.6767 44.4673C34.9869 44.4673 34.4277 45.0265 34.4277 45.7163C34.4277 46.406 34.9869 46.9652 35.6767 46.9652Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M32.3826 12.9241C33.9571 10.217 37.8674 10.217 39.442 12.9241L47.4176 26.6365C49.0009 29.3587 47.037 32.7728 43.8879 32.7728H27.9367C24.7875 32.7728 22.8237 29.3587 24.407 26.6365L32.3826 12.9241Z",
          fill: "#FDC221"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.95 27.859C36.5432 27.859 37.024 27.3781 37.024 26.785C37.024 26.1918 36.5432 25.7109 35.95 25.7109C35.3568 25.7109 34.876 26.1918 34.876 26.785C34.876 27.3781 35.3568 27.859 35.95 27.859Z",
          fill: "#2E3849"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M35.95 23.5516C36.2348 23.5516 36.508 23.4384 36.7094 23.237C36.9109 23.0356 37.024 22.7624 37.024 22.4775V18.1814C37.024 17.8966 36.9109 17.6234 36.7094 17.422C36.508 17.2206 36.2348 17.1074 35.95 17.1074C35.6652 17.1074 35.392 17.2206 35.1906 17.422C34.9891 17.6234 34.876 17.8966 34.876 18.1814V22.4775C34.876 22.7624 34.9891 23.0356 35.1906 23.237C35.392 23.4384 35.6652 23.5516 35.95 23.5516Z",
          fill: "#2E3849"
        }
      )
    ]
  }
);
const ErrorAlert = () => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(HirerBalanceLayout, { children: /* @__PURE__ */ jsxs(Columns, { space: "medium", collapseBelow: "desktop", reverse: true, children: [
    /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(
      Box,
      {
        className: icon,
        display: "flex",
        padding: "large",
        borderRadius: "full",
        background: "surface",
        justifyContent: "center",
        alignItems: "center",
        children: /* @__PURE__ */ jsx(ErrorLogo, {})
      }
    ) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(Text, { size: "large", weight: "strong", children: t("Oops!") }),
      /* @__PURE__ */ jsx(Text, { children: t(
        "A technical error has occurred and we are unable to show your SEEK contract information."
      ) }),
      /* @__PURE__ */ jsx(Text, { children: t("Please refresh the page and try again.") })
    ] }) })
  ] }) });
};
export {
  ErrorAlert
};
